import { render, staticRenderFns } from "./Sdk.vue?vue&type=template&id=6c7abc16&"
import script from "./Sdk.vue?vue&type=script&lang=js&"
export * from "./Sdk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports